import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { PagedResult } from '../models/paged-result.model';

export interface BugReportDto {
  id: string;
  content: string;
  imageUrl?: string;
  reporterName: string;
  /** 0 = Pending, 1 = Resolved */
  status: number;
  createdAt: string;
}

@Injectable({
  providedIn: 'root'
})
export class BugReportService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/bugreports`;

  getReports(
    page: number,
    pageSize: number,
    status?: number,
    search?: string
  ): Observable<PagedResult<BugReportDto>> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('pageSize', pageSize.toString());

    if (status !== undefined && status !== null) {
      params = params.set('status', status.toString());
    }
    if (search) {
      params = params.set('search', search);
    }

    return this.http.get<PagedResult<BugReportDto>>(this.apiUrl, { params });
  }

  getPendingCount(): Observable<number> {
    const params = new HttpParams()
      .set('page', '1')
      .set('pageSize', '1')
      .set('status', '0');
    return this.http.get<PagedResult<BugReportDto>>(this.apiUrl, { params }).pipe(
      map(result => result.totalCount)
    );
  }

  resolve(id: string): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}/resolve`, {});
  }

  delete(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }
}
